module.exports = __webpack_public_path__ + "img/netdocs-badges.94978a42.jpg";